import { motion } from "framer-motion";
import { Text } from "@core/index";
export const AvatarLoader = ({ avatarDetails }: { avatarDetails: string }) => {
  return (
    <motion.div
      className="w-full h-full flex flex-col items-center justify-center space-y-4 relative"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {/* Background video */}
      {avatarDetails && (
        <div className="absolute inset-0 overflow-hidden rounded-lg">
          <video
            src={avatarDetails}
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover opacity-40"
          />
        </div>
      )}

      {/* Glowing loader */}
      <div className="relative w-20 h-20 z-10">
        {/* Outer pulse */}
        <motion.div
          className="absolute inset-0 rounded-full bg-violet-500/20"
          animate={{ scale: [1, 1.2, 1], opacity: [0.6, 0.3, 0.6] }}
          transition={{ repeat: Infinity, duration: 2 }}
        />

        {/* Middle blur glow */}
        <div className="absolute inset-2 rounded-full bg-violet-500/30 blur-md animate-pulse" />

        {/* Spinning ring */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-full h-full border-[3px] border-violet-500 border-dashed rounded-full animate-spin" />
        </div>

        {/* Center dot */}
        <div className="absolute top-1/2 left-1/2 w-4 h-4 -translate-x-1/2 -translate-y-1/2 rounded-full bg-violet-600 shadow-lg" />
      </div>

      {/* Text with animated dots */}
      <div className="text-violet-600 dark:text-violet-300 text-sm font-medium flex items-center z-10">
        <Text variant="span">heygenVideoGenerator.processingVideo</Text>
        <span className="ml-1 flex space-x-1">
          <motion.span
            className="animate-bounce"
            style={{ animationDelay: "0s" }}
          >
            .
          </motion.span>
          <motion.span
            className="animate-bounce"
            style={{ animationDelay: "0.2s" }}
          >
            .
          </motion.span>
          <motion.span
            className="animate-bounce"
            style={{ animationDelay: "0.4s" }}
          >
            .
          </motion.span>
        </span>
      </div>
    </motion.div>
  );
};
